import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function Unauthorized() {
    const navigate = useNavigate();

    // Swal.fire({
    //     text: "Unauthorized Access",
    //     icon: "warning",
    //     backdrop: 'false'
    // }).then((refresh) => {

    //     if (refresh.isConfirmed) {
    //         goBack()
    //     }
    // })

    return (
        <section>
            <h1>Unauthorized</h1>
            <br />
            <p>You do not have access to the requested page.</p>
            <div className="flexGrow">
                <button onClick={() => navigate('/')}>Go Back</button>
            </div>
        </section>
    )

}
